/** Раздел словаря «table»: стол, места, ставки и прогноз, трек этапов, график, результат и проверка. */
export const table = {
  // шапка стола и банк
  'head.leaveHint': 'Вы останетесь участником до конца розыгрыша',
  'head.lobby': '← Лобби',
  'head.title': 'Стол {ante|cr}',
  'head.replay': 'Воспроизведение истории',
  'head.live': 'Реальное время',
  'head.synthetic': 'Синтетические данные',
  'pot.pot': 'Банк',
  'pot.ante': 'Взнос N',

  // лента ходов и раскрытие информации
  'feed.title': 'Ходы участников',
  'feed.hint': 'прогнозы скрыты до расчёта',
  'feed.empty': 'Ходов пока нет',
  'feed.ante': 'взнос',
  'feed.round': 'круг {n}',
  'reveal.title': 'Раскрытие информации',
  'reveal.commitment': 'обязательство {hash}…',
  'reveal.compositionHidden': 'Состав скрыт до круга 3',

  // участие в розыгрыше
  'ready.spectator': 'Вы наблюдаете за столом.',
  'ready.confirmed': 'Участие подтверждено.',
  'ready.anteAtStart': 'Взнос {amount|cr} будет внесён при старте.',
  'ready.cancel': 'Отменить участие',
  'ready.join': 'Участвовать в розыгрыше · взнос {amount|cr}',
  'ready.joinNext': 'Участвовать в следующем розыгрыше · взнос {amount|cr}',
  'ready.notEnough': 'Недостаточно кредитов для взноса.',

  // места за столом
  'seats.participants': 'Участники',
  'seats.atTable': 'За столом',
  'seats.count': '{n}/{max} · суммы в кр.',
  'seats.statsTitle': 'Статистика игрока: розыгрышей {games}, винрейт {winRate}, итог {net} кр.',
  'seats.colPlayer': 'Игрок',
  'seats.colRound': 'Круг',
  'seats.colRoundHint': 'Ставка в текущем круге, кр.',
  'seats.colCommitted': 'Внесено',
  'seats.colCommittedHint': 'Всего внесено в банк розыгрыша, кр.',
  'seats.colStack': 'Остаток',
  'seats.colStackHint': 'Доступный остаток, кр.',
  'seats.colStatus': 'Статус',
  'seats.colBalance': 'Баланс',
  'seats.turn': 'ход · {s} с',
  'seats.me': 'вы',
  'seats.offline': 'нет связи',
  'seats.inGame': 'в розыгрыше',
  'seats.ready': 'готов',
  'seats.waiting': 'ожидает',
  'seats.free': 'свободно',

  // трек этапов
  'stage.chart': '1 · График',
  'stage.chartHint': 'направление',
  'stage.scale': '2 · Шкала',
  'stage.scaleHint': 'цены и пункты',
  'stage.composition': '3 · Состав',
  'stage.compositionHint': 'число пунктов',
  'stage.candle': 'Свеча',
  'stage.candleHint': 'ожидание закрытия',
  'stage.settle': 'Расчёт',
  'stage.settleHint': 'результат',
  'stage.nextIn': 'Набор на следующий розыгрыш через',

  // панель решений: прогноз
  'controls.spectator': 'Вы наблюдаете за розыгрышем. Участвовать можно со следующего розыгрыша.',
  'controls.aria': 'Ваш прогноз и действия',
  'controls.forecast': 'Прогноз',
  'controls.forecastLocked': 'зафиксирован',
  'controls.youFolded': 'вы спасовали',
  'controls.lockIn': 'фиксация через {time}',
  'controls.direction': 'Направление',
  'controls.up': 'Выше',
  'controls.down': 'Ниже',
  'controls.points': 'Пункты',
  'controls.pointsRequired': 'обязательно до фиксации',
  'controls.pointsOptional': 'предварительно, можно позже',
  'controls.pointsLess': 'меньше на {tick}',
  'controls.pointsMore': 'больше на {tick}',
  'controls.pointsInvalid': 'Число пунктов — положительное и кратное {tick}',
  'controls.pointsEnter': 'Введите число пунктов',
  'controls.noticeChooseDirection': 'Выберите направление — без него нельзя вносить кредиты. В круге 3 направление уже не выбрать.',
  'controls.noticeNoDirectionRound3': 'Направление не выбрано, а в круге 3 его уже не выбрать: при фиксации вы выбудете.',
  'controls.noticeRound2': 'В круге 3 направление менять будет нельзя — только число пунктов.',
  'controls.noticeRound3': 'Направление зафиксировано: в круге 3 меняется только число пунктов.',
  'controls.noticeNoPoints': 'Укажите число пунктов: без него при фиксации через {s} с вы выбываете.',

  // панель решений: ставка
  'controls.bet': 'Ставка',
  'controls.bettingClosed': 'круг {n} · ставки завершены',
  'controls.yourTurn': 'ваш ход · {s} с',
  'controls.theirTurn': 'ходит {name} · {s} с',
  'controls.roundBet': 'Ставка круга',
  'controls.toCall': 'К уравниванию',
  'controls.raises': 'Повышения',
  'controls.raisesOf': '{n} из {max}',
  'controls.statusFolded': 'Вы спасовали — участие в этом розыгрыше завершено.',
  'controls.statusAllIn': 'Вы в олл-ине: ставок больше не делаете, прогноз можно менять до фиксации.',
  'controls.statusPrep': 'Первый круг ставок начнётся через {time}.',
  'controls.statusNextRound': 'Все участники сделали ход. Следующий круг ставок откроется через {time} {reveal}.',
  'controls.nextRevealScale': 'вместе со шкалой цен',
  'controls.nextRevealComposition': 'вместе с составом акций',
  'controls.statusLockIn': 'Все участники сделали ход. Прогнозы будут зафиксированы через {time}.',
  'controls.statusWait': 'Дождитесь своего хода. Можно заранее выбрать предварительное действие.',
  'controls.statusRaiseLimit': 'Лимит повышений в этом круге исчерпан — доступны колл или пас.',
  'controls.presetMin': 'Мин',
  'controls.presetHalfPot': '½ банка',
  'controls.presetPot': 'Банк',
  'controls.presetMax': 'Макс',
  'controls.betAmount': 'Сумма ставки',
  'controls.raiseTo': 'Повысить до',
  'controls.range': 'от {min|cr} до {max|cr}',
  'controls.fold': 'Пас',
  'controls.check': 'Чек',
  'controls.call': 'Колл',
  'controls.raise': 'Райз',
  'controls.betAction': 'Ставка',
  'controls.allIn': 'Олл-ин',
  'controls.noDirection': 'Чтобы вносить кредиты, выберите направление прогноза.',
  'controls.foldTitle': 'Пас',
  'controls.foldConfirm': 'Спасовать',
  'controls.foldBody': 'Вы выйдете из розыгрыша. Внесённые {amount|cr} останутся в банке и вернутся только при отмене розыгрыша.',
  'controls.dontAsk': 'Больше не спрашивать',

  // предварительное действие
  'pre.title': 'Предварительное действие',
  'pre.planned': 'запланировано',
  'pre.none': 'Нет',
  'pre.noneHint': 'Без предварительного действия: на своём ходу решаете сами.',
  'pre.checkOnly': 'Чек',
  'pre.checkOnlyHint': 'Чек, если ставки нет. Если кто-то поставил — ход остаётся за вами.',
  'pre.checkFold': 'Чек / пас',
  'pre.checkFoldHint': 'Чек, если ставки нет; если кто-то поставил — пас.',
  'pre.callUpTo': 'Колл до лимита',
  'pre.callUpToHint': 'Колл, если к уравниванию не больше лимита; если ставки нет — чек. Ставка выше лимита — решаете сами.',
  'pre.limit': 'Лимит колла',
  'pre.limitHint': 'больше — решаете сами',
  'pre.onceNext': 'Сработает один раз — на вашем следующем ходу.',
  'pre.onceNearest': 'Сработает один раз — на вашем ближайшем ходу.',

  // подтверждение олл-ина
  'allin.confirm': 'Внести {amount|cr}',
  'allin.bodyBefore': 'Вы вносите весь доступный остаток',
  'allin.bodyAfter': 'и больше не делаете ставок в этом розыгрыше. Прогноз можно менять до общей фиксации.',
  'allin.up': 'выше',
  'allin.down': 'ниже',
  'allin.noDirection': 'не выбрано',
  'allin.points': 'Предварительное число пунктов (обязательно)',
  'allin.pointsPlaceholder': 'кратно {tick}',
  'allin.pointsInvalid': 'Строго положительное число, кратное {tick}.',

  // график
  'chart.myForecast': 'мой прогноз',
  'chart.scaleHidden': 'Шкала цен скрыта до круга 2 · единицы нормированы',
  'chart.waiting': 'Ожидание данных агрегата…',
  'chart.hide': 'Скрыть',
  'chart.show': 'Показать',
  'chart.period': 'период',
  'chart.indicators': 'Индикаторы',
  'chart.activity': 'Активность',

  // результат розыгрыша
  'settle.aria': 'Результат розыгрыша',
  'settle.cancelled': 'Розыгрыш отменён',
  'settle.walkover': 'Остался один участник',
  'settle.title': 'Расчёт',
  'settle.refundedNote': 'взносы возвращены, комиссия не удержана',
  'settle.myNet': 'Ваш итог',
  'settle.composition': 'Состав агрегата:',
  'settle.colPlayer': 'Игрок',
  'settle.colForecast': 'Прогноз',
  'settle.colError': 'Ошибка',
  'settle.colContributed': 'Внесено',
  'settle.colPayout': 'Выплата',
  'settle.colRefund': 'Возврат',
  'settle.colNet': 'Итог',
  'settle.folded': 'пас',
  'settle.wrongDirection': 'неверное направление',
  'settle.pots': 'Банки',
  'settle.colPot': 'Банк',
  'settle.colAmount': 'Сумма',
  'settle.colCommission': 'Комиссия',
  'settle.colRecipients': 'Получатели (вес)',
  'settle.mainPot': 'Основной',
  'settle.sidePot': 'Побочный {n}',
  'settle.potRefunded': 'возвращён внёсшим',
  'settle.commissionByRound': 'Комиссия по кругам',
  'settle.colRound': 'Круг',
  'settle.colNewContributions': 'Новые взносы',
  'settle.withAntes': 'с взносами',
  'settle.cap': 'потолок',
  'settle.toHouse': 'Удержано на счёт банка',
  'settle.reconciliation': 'Сверка: списано {debited|cr} = выплачено {paid|cr} + возвращено {refunded|cr} + банк {bank|cr}',
  'settle.noWinners': 'Выигравших нет.',

  // проверяемость
  'verify.title': 'Проверяемость',
  'verify.commitmentPre': 'Обязательство',
  'verify.commitmentPost': 'опубликовано до ставок —',
  'verify.match': 'совпадает ✓',
  'verify.mismatch': 'не совпадает ✗',
  'verify.checking': 'проверяется…',
  'verify.notRevealed': 'не раскрыто',
  'verify.hideSalt': 'Скрыть соль',
  'verify.showSalt': 'Параметры и соль',
  'verify.inBrowser': 'Проверить в браузере',
  'verify.download': 'Скачать пакет проверки',
  'verify.packageError': 'Пакет проверки: {error}',
};
